import React from 'react';
import Spinner from 'react-bootstrap/Spinner';


function GrowExample() {
  return <Spinner animation="grow" />;
}

export default GrowExample;

